import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';
import { Form, Formik, FormikValues } from 'formik';
import * as Yup from 'yup';

import { Button, Select } from '../../../custom';
import Input from '../../../custom/input/input';
import { createRole } from '../request';
import { StatusOptions } from '../../../requests';

interface Props {
  role: Role;
  handleClose: () => void;
  refetch: () => void;
}

const EditRoleForm = ({ role, handleClose, refetch }: Props) => {
  const { notification } = App.useApp();
  const queryClient = useQueryClient();

  const validate = Yup.object().shape({
    name: Yup.string().required('Role name is required'),
    status: Yup.string(),
  });

  const updateRoleMutation = useMutation({ mutationFn: createRole });

  const handleSubmit = async (values: FormikValues) => {
    try {
      await updateRoleMutation.mutateAsync(
        {
          id: role.id,
          name: values.name,
          normalizedName: values.name.toUpperCase(),
          isActive: values.status === 'true',
        },
        {
          onSuccess: (data) => {
            notification.success({
              message: 'Success',
              description: data?.message || 'Role updated successfully',
            });
            queryClient.refetchQueries({ queryKey: ['get-all-roles'] });
            refetch();
            handleClose();
          },
        },
      );
    } catch (error: any) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message || 'Failed to update role',
      });
    }
  };

  return (
    <Formik
      initialValues={{ name: role.name, status: String(role.isActive) }}
      validationSchema={validate}
      onSubmit={(values) => handleSubmit(values)}
      enableReinitialize
    >
      {() => (
        <Form className="fields">
          <Input label="Role Name" placeholder="Input role name" name="name" />

          {/* <Select
            name="status"
            placeholder="Select Status"
            label="Status"
            options={
              <>
                {StatusOptions.map((option: any) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </>
            }
          /> */}

          <div className="btn-group">
            <Button onClick={handleClose} variant="text" text="Cancel" />
            <Button
              text={updateRoleMutation.isPending ? 'Updating...' : 'Update'}
              type="submit"
              isLoading={updateRoleMutation.isPending}
              disabled={updateRoleMutation.isPending}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default EditRoleForm;
